import styled from "styled-components"

export const Reply = styled.div`
  background-color: ${({ theme }) => theme.pallete.primary.light};
  border-left: 5px solid ${({ theme }) => theme.palette.primary.main};
  padding: 2px 0px !important;
  border-radius: 0.5em;
`
